import React, { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";

const AdminBirthday = () => {
  const [form, setForm] = useState({
    name: "",
    className: "",
    image: null,
  });

  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);

  const fetchData = () => {
    fetch("https://njinternational.ilakshyaerp.in/api/birthday")
      .then((res) => res.json())
      .then((res) => setData(Array.isArray(res) ? res : []));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ ADD + UPDATE
  const handleSubmit = async () => {
    if (!form.name || !form.className) {
      alert("Please fill all fields");
      return;
    }

    if (!editId && !form.image) {
      alert("Please select image");
      return;
    }

    // 🔥 FRONTEND FILE SIZE CHECK
    if (form.image && form.image.size > 10 * 1024 * 1024) {
      alert("Image size must be less than 10MB ❌");
      return;
    }

    const formData = new FormData();
    formData.append("name", form.name);
    formData.append("className", form.className);
    if (form.image) formData.append("image", form.image);

    const url = editId
      ? `https://njinternational.ilakshyaerp.in/api/birthday/${editId}`
      : "https://njinternational.ilakshyaerp.in/api/birthday/add";

    const method = editId ? "PUT" : "POST";

    try {
      const res = await fetch(url, {
        method,
        body: formData,
      });

      const data = await res.json();

      // 🔴 HANDLE BACKEND ERROR
      if (!res.ok) {
        alert(data.message || "Upload failed ❌");
        return;
      }

      // ✅ SUCCESS
      alert(editId ? "Updated successfully ✅" : "Added successfully ✅");

      setForm({ name: "", className: "", image: null });
      setEditId(null);
      fetchData();

    } catch (err) {
      alert("Server error ❌");
    }
  };

  // EDIT
  const handleEdit = (item) => {
    setForm({
      name: item.name,
      className: item.class,
      image: null,
    });
    setEditId(item.id);
  };

  // DELETE
  const handleDelete = (id) => {
    fetch(`https://njinternational.ilakshyaerp.in/api/birthday/${id}`, {
      method: "DELETE",
    })
      .then((res) => res.json())
      .then(() => fetchData());
  };

  return (
    <AdminLayout>
      <div className="notice-page">

        {/* FORM */}
        <div className="notice-card">
          <h2>{editId ? "Update Birthday" : "Add Birthday"}</h2>

          <input
            placeholder="Student Name"
            value={form.name}
            onChange={(e) =>
              setForm({ ...form, name: e.target.value })
            }
          />

          <input
            placeholder="Class"
            value={form.className}
            onChange={(e) =>
              setForm({ ...form, className: e.target.value })
            }
          />

          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            onChange={(e) =>
              setForm({ ...form, image: e.target.files[0] })
            }
          />

          <button onClick={handleSubmit}>
            {editId ? "Update" : "Add"}
          </button>
        </div>

        {/* TABLE */}
        <div className="notice-table">
          <table>
            <thead>
              <tr>
                <th>Image</th>
                <th>Name</th>
                <th>Class</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {data.length > 0 ? (
                data.map((d) => (
                  <tr key={d.id}>
                    <td>
                      <img
                        src={`https://njinternational.ilakshyaerp.in/uploads/birthday/${d.image}`}
                        width="60"
                        alt="student"
                      />
                    </td>

                    <td>{d.name}</td>
                    <td>{d.class}</td>

                    <td>
                      <button
                        className="edit-btn"
                        onClick={() => handleEdit(d)}
                      >
                        Edit
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(d.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

      </div>
    </AdminLayout>
  );
};

export default AdminBirthday;